import { WebApiClient } from "@verity/api-client";
import { getInferredBrowserExtensionId } from "@verity/extension/platform";
import { dispatchProxyMessage } from "@verity/extension/proxy-message/external";

/**
 * Gets the currently shared Api Client for this configuration.
 */
const apiClientPlatformConfig = {
	verityOrigin: window.location.origin,
	visualizerOrigin: import.meta.env.VITE_VISUALIZERS_S3_BUCKET_URL,
	lockdown: {
		origin: import.meta.env.VITE_LOCKDOWN_S3_BUCKET_URL,
		channel: import.meta.env.VITE_LOCKDOWN_CHANNEL,
		cdnBaseUrl: import.meta.env.VITE_LOCKDOWN_CDN_BASE_URL,
	},
	candidateAi: import.meta.env.VITE_CANDIDATE_AI_CHANNEL
		? { channel: import.meta.env.VITE_CANDIDATE_AI_CHANNEL }
		: undefined,
	moodlePlugin: import.meta.env.VITE_MOODLE_PLUGIN_CHANNEL
		? { channel: import.meta.env.VITE_MOODLE_PLUGIN_CHANNEL }
		: undefined,
};

const apiClient = WebApiClient.getInstance(apiClientPlatformConfig);
export default apiClient;

function sendExtensionAuthCodeMessage(payload: { accountId?: string; authCode: string }) {
	return new Promise((res) => {
		dispatchProxyMessage("loginUsingAuthCode", { accountId: payload.accountId!, authCode: payload.authCode })
			.then(() => res(true))
			.catch((e) => {
				console.error(`Proxy message "loginUsingAuthCode" failed, attempting fallback:`, e);
				/**
				 * @deprecated remove after extension rollout
				 */
				return chrome.runtime.sendMessage(getInferredBrowserExtensionId(), {
					request: "authCode",
					payload: { accountId: payload.accountId!, authCode: payload.authCode },
				});
			})
			.then(() => res(true))
			.catch((e) => {
				console.error(`Extension 'authCode' external message error, fallback failed: ${e}`);
				res(false);
			});
	});
}

export async function sendExtensionAuthCode() {
	const payload = await apiClient.authentication.getAccessControlAuthCode();
	await sendExtensionAuthCodeMessage(payload);
}

export async function sendPlatformAuthCodes() {
	const payload = await apiClient.authentication.getAccessControlAuthCode();
	window.top?.postMessage(
		{
			subject: "__VERITY_AUTH",
			payload,
			verityOrigin: import.meta.env.VITE_VERITY_ORIGIN,
		},
		"*",
	);
	void sendExtensionAuthCodeMessage(payload);
}
